module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sidebar":{"overview":"Overview","workspace":"Workspace","payment":"Payment","seatmanagement":"Seat Management"}},"th":{"sidebar":{"overview":"ภาพรวม","workspace":"เวิร์คสเปซ","payment":"การชำระเงิน","seatmanagement":"การจัดการที่นั่ง"}}}')
  delete Component.options._Ctor
}
